/**
 * @param {object} state
 * @param {object} project
 */
const addProject = (state, project) => {
  state.projects.unshift(project)
}

/**
 * @param {object} state
 * @param {number} projectId
 */
const deleteProject = (state, projectId) => {
  const index = state.projects.findIndex(c => c.id === projectId)

  state.projects.splice(index, 1)
}

/**
 * @param {object}   state
 * @param {object[]} payload
 */
const setProjects = (state, payload) => {
  state.projects = payload
}

/**
 * @param {object} state
 * @param {object} project
 */
const updateProject = (state, project) => {
  const index = state.projects.findIndex(c => c.id === project.id)

  state.projects.splice(index, 1, project)
}

/**
 * @type {object}
 */
const mutations = {
  addProject,
  deleteProject,
  setProjects,
  updateProject
}

export default mutations
